export var calendarLegendTheme = {
  baseStyle: {
    container: {
      display: 'flex',
      flexDir: 'row',
      alignItems: 'baseline',
      gridGap: 'xs'
    },
    indicator: {
      w: '8px',
      h: '8px',
      minW: '8px',
      minH: '8px',
      borderRadius: 'full',
      border: 'input-thick.readOnly',
      _selected: {
        border: 'input-thick.brand',
        bgColor: 'brand.main'
      }
    },
    textContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      color: 'neutral.darkest',
      columnGap: 'xxs'
    },
    label: {
      textStyle: 'body4',
      whiteSpace: 'nowrap'
    },
    date: {
      textStyle: 'body4Semi'
    }
  }
};
//# sourceMappingURL=CalendarLegend.theme.js.map